import React, { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import ThemedTextField from 'components/common/ThemedTextField';
const toPrecision = (number, precision) => precision === undefined ? number : Math.floor(number * Math.pow(10, precision)) / Math.pow(10, precision);
const QuantityCell = ({ cellValue, onChange, disabled, precision, setRowBusy, updateStartHook, }) => {
    const { t } = useTranslation('orders');
    const [quantity, setQuantity] = useState('');
    useEffect(() => {
        var _a, _b;
        setQuantity((_b = (_a = cellValue.value) === null || _a === void 0 ? void 0 : _a.toString()) !== null && _b !== void 0 ? _b : '');
        setRowBusy === null || setRowBusy === void 0 ? void 0 : setRowBusy((busy) => busy.filter((id) => id !== cellValue.id));
    }, [cellValue.value, cellValue.id, setQuantity, setRowBusy]);
    const handleChange = useCallback((e) => {
        var _a;
        updateStartHook === null || updateStartHook === void 0 ? void 0 : updateStartHook();
        const inputValue = (_a = e.target.value) === null || _a === void 0 ? void 0 : _a.replace(',', '.');
        const parsedValue = precision === 0
            ? parseInt(inputValue.split(/[.,]/)[0], 10) || 0
            : toPrecision(parseFloat(inputValue) || 0, precision);
        setQuantity(precision === 0 ? parsedValue === null || parsedValue === void 0 ? void 0 : parsedValue.toString() : inputValue);
        setRowBusy === null || setRowBusy === void 0 ? void 0 : setRowBusy((busy) => [...busy, cellValue.id]);
        onChange(cellValue.id, Math.abs(parsedValue));
    }, [updateStartHook, precision, setRowBusy, onChange, cellValue.id]);
    return (React.createElement("div", { className: "quantity-cell" },
        React.createElement("div", null,
            React.createElement(ThemedTextField, { value: quantity, unit: cellValue.unit, decimalScale: precision || 2, className: "quantity-cell", disabled: disabled, label: t('common:amount'), onChange: handleChange, numeric: precision !== 0, hideClearIcon: true })),
        (cellValue === null || cellValue === void 0 ? void 0 : cellValue.expectedValue) !== undefined && (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "ml-1 mr-1" }, "/"),
            React.createElement("div", null, `${cellValue === null || cellValue === void 0 ? void 0 : cellValue.expectedValue}`)))));
};
export default QuantityCell;
